import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MessageBusService {
  private channel = new BroadcastChannel('incibe-channel');
  private readonly message$ = new Subject<any>();

  constructor() {
    this.channel.onmessage = (event) => {
      this.message$.next(event.data);
    };
  }

  send(message: any) {
    this.channel.postMessage(message);
  }

  listen() {
    return this.message$.asObservable();
  }
}
